import { addNote } from '@/store/modules/add_note';
import { addSessionResults } from '@/store/modules/add_session_results';
import { addResultsAttendance } from '@/store/modules/add-results/attendance';
import { addResultsErgo } from '@/store/modules/add-results/ergo';
import { addResultsImportData } from '@/store/modules/add-results/importData';
import { addResultsMain } from '@/store/modules/add-results/add_results';
import { addResultsWater } from '@/store/modules/add-results/water';
import { calendar } from '@/store/modules/calendar';
import { calendarQuickAssign } from '@/store/modules/calendar_quick_assign';
import { challenges } from '@/store/modules/challenges';
import { clubMembers } from '@/store/modules/club_members';
import { createMorningMonitoring } from '@/store/modules/create_morning_monitoring';
import { createCrew } from '@/store/modules/create_crew';
import { crews } from '@/store/modules/crews';
import { drvImportFile } from '@/store/modules/drv_import_file';
import { editMember } from '@/store/modules/edit_member';
import { editSession } from '@/store/modules/edit_session';
import { equipment } from '@/store/modules/equipment';
import { globalNotifications } from '@/store/modules/global_notifications';
import { sessionAttendance } from '@/store/modules/session_attendance';
import { sessionDetails } from '@/store/modules/session_details';
import { sessionEquipment } from '@/store/modules/session_equipment';
import { sessionResults } from '@/store/modules/session-results/session';
import { sessionResultsFilter } from '@/store/modules/session-results/filter';
import { sessionResultsNavigation } from '@/store/modules/session-results/navigation';
import { squads } from '@/store/modules/squads';
import { profileCalendar } from '@/store/modules/profile/calendar';
import { profileMorningMonitoring } from '@/store/modules/profile/morning-monitoring';
import { profileNotes } from '@/store/modules/profile/notes';
import { reportsGMT } from '@/store/modules/reports/gmt';
import { reportsErgo } from '@/store/modules/reports/ergo';
import { resultsFilter } from '@/store/modules/add-results/filter';
import { reportsMorningMonitoring } from '@/store/modules/reports/morning-monitoring';
import { reportsWater } from '@/store/modules/reports/water';
import { reportsAttendance } from '@/store/modules/reports/attendance';
import { reportsTrainingSummary } from '@/store/modules/reports/training-summary';
import { reportsKaizenTeam } from '@/store/modules/reports/kaizen-team';
import { reportsTeamErgoSummary } from '@/store/modules/reports/team-ergo-summary';
import { reportsRPE } from '@/store/modules/reports/rpe';
import { reportsStepTests } from '@/store/modules/reports/step-tests';
import { reportsVo2Tests } from '@/store/modules/reports/vo2-tests';
import { reports2kTests } from '@/store/modules/reports/2k-tests';
import { reports6kTests } from '@/store/modules/reports/6k-tests';
import { widgetAutoImport } from '@/store/modules/widget_auto_import';
import { request, handleResponse } from '@/components/http';
import auth from '@/store/modules/auth';
import clubHelper from '@/store/modules/club_helper';
import createSession from '@/store/modules/create_session';
import modals from '@/store/modules/modals';
import user from '@/store/modules/user';
import title from './modules/title';
import { adminClubs } from '@/store/admin/modules/clubs';
import { adminUsers } from '@/store/admin/modules/users';

import Vuex from 'vuex';
import Worker from 'worker-loader!@/http-worker';

const worker = new Worker();
worker.onmessage = handleResponse;

Vue.use(Vuex);

import { LUDUM_ERROR_CODES } from '@/constants';
import get from 'get-object-path';
import router from '@/router';
import { ROUTES_LOGIN, ROUTES_UNAUTHORIZED } from '@/constants/routes';

const store = new Vuex.Store({
    modules: {
        addNote,
        addSessionResults,
        auth,
        modals,
        addResultsAttendance,
        addResultsErgo,
        addResultsImportData,
        addResultsMain,
        addResultsWater,
        calendar,
        calendarQuickAssign,
        challenges,
        clubHelper,
        clubMembers,
        createMorningMonitoring,
        createSession,
        createCrew,
        crews,
        drvImportFile,
        editMember,
        editSession,
        equipment,
        globalNotifications,
        profileCalendar,
        profileMorningMonitoring,
        profileNotes,
        reportsAttendance,
        reportsErgo,
        reportsGMT,
        reportsMorningMonitoring,
        reportsRPE,
        reportsWater,
        reportsStepTests,
        reportsTrainingSummary,
        reportsKaizenTeam,
        reportsTeamErgoSummary,
        reportsVo2Tests,
        reports2kTests,
        reports6kTests,
        resultsFilter,
        sessionAttendance,
        sessionDetails,
        sessionEquipment,
        sessionResults,
        sessionResultsFilter,
        sessionResultsNavigation,
        squads,
        user,
        widgetAutoImport,
        title,
        adminClubs,
        adminUsers
    },
    state: {},
    mutations: {},
    actions: {
        post(context, payload) {
            const { url, data, config } = payload;
            return request(
                {
                    method: 'post',
                    url,
                    data,
                    config
                },
                worker
            );
        },

        get(context, payload) {
            const { config, params, url } = payload;

            return request(
                {
                    method: 'get',
                    url,
                    config,
                    params
                },
                worker
            ).catch(error => {
                const status = get(error, 'response.status');

                if (status === LUDUM_ERROR_CODES.UNAUTHORIZED) {
                    handleUnauthorized();
                    return error.response.statusText;
                }

                if (status === LUDUM_ERROR_CODES.FORBIDDEN) {
                    const message = get(error, 'response.data.message');
                    handleForbidden(message);
                    return message;
                }

                throw error;
            });
        },

        delete(context, payload) {
            const { config, url } = payload;

            return request(
                {
                    method: 'delete',
                    url,
                    config
                },
                worker
            ).catch(error => {
                const status = get(error, 'response.status');

                if (status === LUDUM_ERROR_CODES.UNAUTHORIZED) {
                    handleUnauthorized();
                    return error.response.statusText;
                }

                throw error;
            });
        }
    }
});

const initialStateCopy = Object.assign({}, store.state);

export function resetState() {
    store.replaceState(initialStateCopy);
}

function handleUnauthorized() {
    Vue.auth.destroyToken();
    Vue.cookie.delete('selectedClub');
    localStorage.clear();
    router.push({ name: ROUTES_LOGIN });
}

function handleForbidden(message) {
    router.push({ name: ROUTES_UNAUTHORIZED, params: { message: message } });
}

export default store;
